<template>
  <div>
    <header>
      <h5 class="msg-reg-js">
        Fill out the fields below to reset your password
      </h5>
    </header>
    <el-form style="margin-top: 30px" @submit.native.prevent class="reset-form">
      <el-row style="margin-bottom: 0">
        <el-col>
          <el-form-item :error="retrieveFieldError(modelState, 'Password')" :required="true">
            <el-input placeholder="Choose a password" type="password" v-model="resetInformation.password" show-password style="margin-top:-10px"></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom:15px" :error="retrieveFieldError(modelState, 'ConfirmPassword') || retrieveFieldError(modelState, 'password.confirmPassword')" :required="true">
            <el-input placeholder="Confirm password" type="password" v-model="resetInformation.confirmPassword" show-password style="margin-top:-10px"></el-input>
          </el-form-item>

          <PasswordChecklist
            v-if="passwordCriteriaResult.length > 0"
            :Data="passwordCriteriaResult"
          ></PasswordChecklist>
        </el-col>
      </el-row>
      <el-row style="margin-top: 25px">
        <el-col>
          <button
            :class="{ loading: isLoading }"
            class="ts-btn ts-btn-rounded ts-btn-secondary ts-btn-full"
            @click="reset()"
          >
            Reset Password
          </button>
          <div style="margin-top: 10px; text-align: center">
            <p class="secondary-p">
              Go back to login <a href="/jobseeker-login">Login here</a>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import PasswordChecklist from "../components/PasswordChecklist";
export default {
  components: {
    PasswordChecklist,
  },
  created() {
    this.resetInformation.token = this.$route.params.token;
    this.resetInformation.email = atob(this.$route.params.email);
  },
  data() {
    return {
      modelState: {},
      resetInformation: {},
      isLoading: false,
      passwordCriteriaResult: [],
    };
  },
  methods: {
    reset() {
      this.isLoading = true;
      this.$store
        .dispatch("account/resetuserpassword", this.resetInformation)
        .then(() => {
          this.isLoading = false;
          this.$router.push({ name: "jobseeker-login" });
          this.$message.success("Password reset success!");
        })
        .catch((res) => {
          this.passwordCriteriaResult = [];
          if (res.errors !== undefined) {
            let password = res.errors['Password'];
            if (password) {
              if (password.find((c) => c.indexOf(",") != -1)) {
                this.passwordCriteriaResult = password;
                res.errors['Password'] = [];
              }
            }
          }

          this.modelState = res.errors;
          this.isLoading = false;
        });
    },
  },
};
</script>
